// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dij1","left":"styles_left__2J2ZH","desktopActions":"styles_desktopActions__2-_QS","title":"styles_title__3xlLi"};